import { Model } from 'modules/core/lib/mobx-rest'

interface ILog {
  id: string
  document_id: string
  log_type: string
  payload: { [key: string]: string | number }
  created_at: string
}

class Log extends Model<ILog> {
  static urlRoot() {
    return '/document_logs'
  }
}

export default Log
